module.exports = __webpack_public_path__ + "img/start.b17ee911.png";